import { clearAllInFlightGets } from './in-flight-requests-store'
import { clearSessionRecovery } from './session-recovery-store'

export function clearInFlightRequests(): void {
  clearAllInFlightGets()
  clearSessionRecovery()
}
